import * as React from 'react'


import { PeriodSelection } from '@/app/models/periodSelection'
import { getSelectionTypeIcon } from '@/app/common/converters/selectionTypeToIconConverter'

import { useScene } from '../context/SceneContext'
import { useConfig } from '../context/ConfigContext'
import { BOTTOM_PADDING } from '../utils/layout'

export type PeriodSelectionBlockProps = {
  selection: PeriodSelection
  index: number
  onSelected?: (selection: PeriodSelection) => void
}

export const PeriodSelectionBlock: React.FC<PeriodSelectionBlockProps> =
  React.memo((props: PeriodSelectionBlockProps) => {
    const scene = useScene()
    const { translate } = useConfig()
    const { selection } = props

    const left = scene.timeToX(selection.time) - 8

    let icon = `/assets/icons/trips/${getSelectionTypeIcon(selection.type)}`
    if (selection.active) {
      icon += '.aktywny'
    }
    icon += '.svg'

    return (
      <div
        className="tw-flex tw-flex-col tw-justify-end"
        style={{
          left,
          position: 'absolute',
          top: 0,
          bottom: 0,
             paddingBottom: BOTTOM_PADDING,
        }}
      >
        <div style={{ position: 'relative' }}>
          <div
            className="tw-flex tw-flex-col tw-items-center tw-justify-center"
            style={{ width: 20, height: scene.height + 15, pointerEvents: 'auto' }}
            onClick={() => {
              props.onSelected && props.onSelected(selection)
            }}
            title={translate('selectedPeriod.clickToMove')}
          >
            <img
              style={{ width: 20, height: 20, cursor: 'pointer' }}
              src={icon}
              alt="img"
            />
            <div
              style={{
                width: 3,
                height: scene.height + 15,
                background: selection.active ? '#2B2E33' : '#000',
                marginLeft: -1,
              }}
            />
          </div>
        </div>
      </div>
    )
  })

PeriodSelectionBlock.displayName = 'PeriodSelectionBlock'
